import { IntlShape } from "react-intl";

export interface customSettingField {
  key: string;
  label: string;
  value?: string;
}

const RATE_MANAGEMENT_CUSTOM_SETTING_FIELDS = (intl: IntlShape): customSettingField[] => [
  {
    key: "lane_selection_outcome",
    label: intl.formatMessage({
      id: "settings.notifications.laneSelectionOutcome",
      defaultMessage: "Lane selection outcome",
    }),
  },
  {
    key: "tender_canceled",
    label: intl.formatMessage({
      id: "settings.notifications.tenderCanceled",
      defaultMessage: "Tender canceled",
    }),
  },
  {
    key: "tender_updated",
    label: intl.formatMessage({
      id: "settings.notifications.tenderUpdated",
      defaultMessage: "Tender updated",
    }),
  },
  {
    key: "new_tender",
    label: intl.formatMessage({
      id: "settings.notifications.newTender",
      defaultMessage: "New tender",
    }),
  },
  {
    key: "tender_comment",
    label: intl.formatMessage({
      id: "settings.notifications.tenderComment",
      defaultMessage: "Tender comment",
    }),
  },
];

const REQUEST_NOTIFICATIONS_CUSTOM_SETTING_FIELDS = (intl: IntlShape): customSettingField[] => [
  {
    key: "provider_changes_a_quote",
    label: intl.formatMessage({
      id: "settings.notifications.providerChangesQuote",
      defaultMessage: "Provider changes a quote",
    }),
  },
  {
    key: "provider_loses_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.providerLosesShipment",
      defaultMessage: "Provider loses Shipment",
    }),
  },
  {
    key: "provider_posts_a_comment",
    label: intl.formatMessage({
      id: "settings.notifications.providerPostsComment",
      defaultMessage: "Provider posts a comment",
    }),
  },
  {
    key: "provider_submits_a_quote",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsQuote",
      defaultMessage: "Provider submits a quote",
    }),
  },
  {
    key: "quotation_timer_has_ended",
    label: intl.formatMessage({
      id: "settings.notifications.quotationTimerHasEnded",
      defaultMessage: "Quotation timer has ended",
    }),
  },
  {
    key: "quote_request_team_assignment",
    label: intl.formatMessage({
      id: "settings.notifications.teamAssignment",
      defaultMessage: "Team assignment",
    }),
  },
  {
    key: "quoting_deadline_reminder",
    label: intl.formatMessage({
      id: "settings.notifications.quotingDeadlineReminder",
      defaultMessage: "Quoting deadline reminder",
    }),
  },
  {
    key: "rate_card_quote_added",
    label: intl.formatMessage({
      id: "settings.notifications.rateCardQuoteAdded",
      defaultMessage: "Rate card quote added",
    }),
  },
  {
    key: "reminder_to_quote",
    label: intl.formatMessage({
      id: "settings.notifications.reminderToQuote",
      defaultMessage: "Reminder to quote",
    }),
  },
  {
    key: "shipper_cancels_quote_request",
    label: intl.formatMessage({
      id: "settings.notifications.shipperCancelsQuoteRequest",
      defaultMessage: "Shipper cancels quote request",
    }),
  },
  {
    key: "shipper_request_quote_extension",
    label: intl.formatMessage({
      id: "settings.notifications.shipperRequestQuoteExtension",
      defaultMessage: "Shipper request quote extension",
    }),
  },
  {
    key: "shipper_submits_new_quote_request",
    label: intl.formatMessage({
      id: "settings.notifications.shipperSubmitsNewQuoteRequest",
      defaultMessage: "Shipper submits new Quote Request",
    }),
  },
  {
    key: "shipper_updates_request",
    label: intl.formatMessage({
      id: "settings.notifications.shipperUpdatesRequest",
      defaultMessage: "Shipper updates a request",
    }),
  },
];

const SHIPMENT_NOTIFICATIONS_CUSTOM_SETTING_FIELDS = (intl: IntlShape): customSettingField[] => [
  {
    key: "automated_tracking_event",
    label: intl.formatMessage({
      id: "settings.notifications.automatedTrackingEvent",
      defaultMessage: "Automated tracking event",
    }),
  },
  {
    key: "intransit_additional_cost_approval",
    label: intl.formatMessage({
      id: "settings.notifications.intransitAdditionalCostApproval",
      defaultMessage: "In transit additional cost approval",
    }),
  },
  {
    key: "new_lane_contract_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.newLaneContractShipment",
      defaultMessage: "New Lane Contract shipment",
    }),
  },
  {
    key: "pod_reminder_24_hrs",
    label: intl.formatMessage({
      id: "settings.notifications.podReminder24Hrs",
      defaultMessage: "POD Reminder > 24 hrs",
    }),
  },
  {
    key: "pod_reminder_96_hrs",
    label: intl.formatMessage({
      id: "settings.notifications.podReminder96Hrs",
      defaultMessage: "POD Reminder > 96 hrs",
    }),
  },
  {
    key: "provider_edits_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.providerEditsShipment",
      defaultMessage: "Provider edits shipment",
    }),
  },
  {
    key: "provider_posts_document",
    label: intl.formatMessage({
      id: "settings.notifications.providerPostsDocument",
      defaultMessage: "Provider posts document",
    }),
  },
  {
    key: "provider_posts_update",
    label: intl.formatMessage({
      id: "settings.notifications.providerPostsUpdate",
      defaultMessage: "Provider posts update",
    }),
  },
  {
    key: "provider_reminder_24_hrs_after_pickup_time",
    label: intl.formatMessage({
      id: "settings.notifications.reminderToUpdate",
      defaultMessage: "Reminder to update",
    }),
  },
  {
    key: "provider_reminder_8_hrs_before_pickup_time",
    label: intl.formatMessage({
      id: "settings.notifications.reminderToAcknowledge",
      defaultMessage: "Reminder to acknowledge",
    }),
  },
  {
    key: "provider_submits_delayed_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsDelayedPOD",
      defaultMessage: "Provider submits delayed POD",
    }),
  },
  {
    key: "provider_submits_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsPOD",
      defaultMessage: "Provider submits POD",
    }),
  },
  {
    key: "provider_submits_pop",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsPOP",
      defaultMessage: "Provider submits POP",
    }),
  },
  {
    key: "provider_submits_pop_and_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsPOPAndPOD",
      defaultMessage: "Provider submits POP and POD",
    }),
  },
  {
    key: "provider_submits_delayed_pop_and_pod",
    label: intl.formatMessage({
      id: "settings.notifications.providerSubmitsDelayedPOPAndPOD",
      defaultMessage: "Provider submits POP and Delayed POD",
    }),
  },
  {
    key: "provider_wins_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.shipmentIsBooked",
      defaultMessage: "A shipment is booked",
    }),
  },
  {
    key: "shipment_auto_closed",
    label: intl.formatMessage({
      id: "settings.notifications.shipmentAutoClosure",
      defaultMessage: "Shipment auto closure",
    }),
  },
  {
    key: "shipper_cancels_booked_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.shipperCancelsBookedShipment",
      defaultMessage: "Shipper cancels booked shipment",
    }),
  },
  {
    key: "shipper_edits_shipment",
    label: intl.formatMessage({
      id: "settings.notifications.shipperEditsShipment",
      defaultMessage: "Shipper edits shipment",
    }),
  },
  {
    key: "shipper_posts_document",
    label: intl.formatMessage({
      id: "settings.notifications.shipperPostsDocument",
      defaultMessage: "Shipper posts document",
    }),
  },
  {
    key: "shipper_posts_update",
    label: intl.formatMessage({
      id: "settings.notifications.shipperPostsUpdate",
      defaultMessage: "Shipper posts update",
    }),
  },
  {
    key: "shipper_requests_customs_broker",
    label: intl.formatMessage({
      id: "settings.notifications.shipperRequestsCustomsBroker",
      defaultMessage: "Shipper requests customs broker",
    }),
  },
];

const BILLING_NOTIFICATIONS_CUSTOM_SETTING_FIELDS = (intl: IntlShape): customSettingField[] => [
  {
    key: "invoice_reminder",
    label: intl.formatMessage({
      id: "settings.notifications.invoiceReminder",
      defaultMessage: "Invoice reminder",
    }),
  },
  {
    key: "payment_status_change",
    label: intl.formatMessage({
      id: "settings.notifications.paymentStatusChange",
      defaultMessage: "Payment status change",
    }),
  },
  {
    key: "provider_reminded_for_cancelation_cost",
    label: intl.formatMessage({
      id: "settings.notifications.providerRemindedForCancelationCost",
      defaultMessage: "Provider reminded for cancelation cost",
    }),
  },
  {
    key: "shipper_declines_invoice",
    label: intl.formatMessage({
      id: "settings.notifications.shipperDeclinesInvoice",
      defaultMessage: "Shipper declines invoice",
    }),
  },
  {
    key: "shipper_posts_comment_on_invoice",
    label: intl.formatMessage({
      id: "settings.notifications.shipperPostsCommentOnInvoice",
      defaultMessage: "Shipper posts comment on invoice",
    }),
  },
];

export {
  RATE_MANAGEMENT_CUSTOM_SETTING_FIELDS,
  REQUEST_NOTIFICATIONS_CUSTOM_SETTING_FIELDS,
  SHIPMENT_NOTIFICATIONS_CUSTOM_SETTING_FIELDS,
  BILLING_NOTIFICATIONS_CUSTOM_SETTING_FIELDS,
};
